import { TripOutput } from '@allocab/allocab-passenger-shared-types';
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import driverImage from '../../../assets/images/driver.png';
import searchImage from '../../../assets/images/search-light.svg';
import { t } from '../../../services/translation/translation';
import { formatTimeBySeconds } from '../../../utils/date';

interface Props {
  searchingDriverRef: React.RefObject<HTMLDivElement>;
  trip: TripOutput;
}
export const SearchingDriver = ({ searchingDriverRef, trip }: Props) => {
  const [rerender, setRerender] = useState(false);
  const etaInMillis = trip?.etaBeforeDriverAssignment ? trip.etaBeforeDriverAssignment * 60 * 1000 : 0;
  const bookedAt = trip.resume.history?.bookedAt ? trip.resume.history.bookedAt : 0;
  useEffect(() => {
    const intervalId = setInterval(() => {
      setRerender(rerender => !rerender);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [rerender]);
  const now = Date.now();
  // Estimated driver assignment
  const assignment = bookedAt + etaInMillis;
  // Has estimate been exceeded
  const isLate = now > assignment;
  // If estimate is exceeded, add more time to keep the timer running (max 1 min)
  const additionalMillis = isLate ? Math.ceil((now - assignment) / 1000 / 60) * 60 * 1000 : 0;
  // Newly estimated time of assignment
  const head = assignment + additionalMillis;
  // Total of potential waiting time for the passenger
  const total = etaInMillis + additionalMillis;
  // Time left before assignment
  const timeLeft = head - now;
  // Progress bar completion percentage
  const progress = 100 - Math.round((timeLeft / total) * 100);

  return (
    <div className="flex justify-between items-center gap-x-2">
      <div className="flex-col flex w-full">
        <strong>{t('share-route.trip-detail.searching-driver')}</strong>
        <div className="flex items-center">
          <span className="mr-2">{formatTimeBySeconds(timeLeft / 1000)}</span>
          <div className="h-2 bg-platinum relative rounded-full w-full">
            <div
              className={`h-2 absolute rounded-l-full ${progress === 100 ? 'rounded-r-full' : ''} bg-primary`}
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      </div>
      <img alt="search" className="h-8" src={searchImage} />
      {searchingDriverRef?.current &&
        createPortal(
          <div className="absolute bottom-0 top-0 left-0 right-0  flex items-center justify-center">
            <div className="w-full h-full flex absolute items-center justify-center bg-overlay"></div>
            <div className="bg-background w-14 h-14 rounded-full absolute animate-firstcircle"></div>
            <div className="bg-background w-14 h-14 rounded-full absolute animate-secondcircle"></div>
            <div className="bg-background w-14 h-14 rounded-full absolute animate-thirdcircle"></div>
            <img alt="driver" className="h-30 z-10" src={driverImage} />
          </div>,
          // document.getElementById('map-container'),
          searchingDriverRef.current,
        )}
    </div>
  );
};
